module.exports = __webpack_public_path__ + "static/images/technology_1_6.6be8b6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology_1_6.png
// module id = MFJG
// module chunks = 8